import { styled } from '@mui/material/styles'
import { Stack } from '@mui/material'

export const SectionItem = styled(Stack)({
  transition: 'max-width 0.15s',
  width: '100%',
  marginLeft: 'auto',
  marginRight: 'auto',
  '&:not(:has(> *))': {
    display: 'none',
  },
})
